// App constants
export const SCREEN_SIZES = ['Mobile', 'Desktop', 'CTV'];

export const HOME_PATHS = [
  '/wp-content/themes/criteo2017/react/ad-gallery/build/ad-gallery/',
  '/',
  '/ad-gallery/',
  '/es/ad-gallery/',
  '/es/',
  '/kr/ad-gallery/',
  '/de/ad-gallery/',
  '/fr/ad-gallery/',
  '/br/ad-gallery/',
  '/jp/ad-gallery/',
  '/it/ad-gallery/',
  '/ru/ad-gallery/',
  '/pl/ad-gallery/',
  '/cn/ad-gallery/',
];

export const AD_SIZE_PATTERNS = {
  REGEX: /^\d{2,3}x\d{2,3}$/,
  PREFERRED_ORDER: ['16:9', '300x250', '300x600']
};

export const DEVICE_BREAKPOINTS = {
  DESKTOP: 992
};

export const LOCALE_MAPPING = {
  'PT': 'BR',
  'JA': 'JP', 
  'KO': 'KR'
};
